import * as React from 'react';

type ListProps = {
  size?: number;
  color?: string;
};

export function List({
  size = 18,
  color = '#191F2E',
}: ListProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule='evenodd'
        clipRule="evenodd"
        d="M5.625 12.9375C5.625 12.6268 5.87684 12.375 6.1875 12.375H16.3125C16.6232 12.375 16.875 12.6268 16.875 12.9375C16.875 13.2482 16.6232 13.5 16.3125 13.5H6.1875C5.87684 13.5 5.625 13.2482 5.625 12.9375Z"
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule="evenodd"
        d="M5.625 8.4375C5.625 8.12684 5.87684 7.875 6.1875 7.875H16.3125C16.6232 7.875 16.875 8.12684 16.875 8.4375C16.875 8.74816 16.6232 9 16.3125 9H6.1875C5.87684 9 5.625 8.74816 5.625 8.4375Z"
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule="evenodd"
        d="M5.625 3.9375C5.625 3.62684 5.87684 3.375 6.1875 3.375H16.3125C16.6232 3.375 16.875 3.62684 16.875 3.9375C16.875 4.24816 16.6232 4.5 16.3125 4.5H6.1875C5.87684 4.5 5.625 4.24816 5.625 3.9375Z"
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule="evenodd"
        d="M2.25 5.0625C2.87132 5.0625 3.375 4.55882 3.375 3.9375C3.375 3.31618 2.87132 2.8125 2.25 2.8125C1.62868 2.8125 1.125 3.31618 1.125 3.9375C1.125 4.55882 1.62868 5.0625 2.25 5.0625Z"
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule="evenodd"
        d="M2.25 9.5625C2.87132 9.5625 3.375 9.05882 3.375 8.4375C3.375 7.81618 2.87132 7.3125 2.25 7.3125C1.62868 7.3125 1.125 7.81618 1.125 8.4375C1.125 9.05882 1.62868 9.5625 2.25 9.5625Z"
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule="evenodd"
        d="M2.25 14.0625C2.87132 14.0625 3.375 13.5588 3.375 12.9375C3.375 12.3162 2.87132 11.8125 2.25 11.8125C1.62868 11.8125 1.125 12.3162 1.125 12.9375C1.125 13.5588 1.62868 14.0625 2.25 14.0625Z"
        fill={color}
      />
    </svg>
  );
}
